import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Border } from "../../foundations/palette.es.js";
import { theme } from "../../foundations/theme.es.js";
import useIsMobile from "../../hooks/use-is-mobile.es.js";
import { styled } from "@mui/material";
import { Positioning } from "../../foundations/positioning.es.js";
import MuiAppBar from "../../../node_modules/@mui/material/AppBar/AppBar.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import Toolbar$1 from "../../../node_modules/@mui/material/Toolbar/Toolbar.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
function AppBar({
  children,
  ...rest
}) {
  const isMobile = useIsMobile();
  return /* @__PURE__ */ jsx(Box, { sx: {
    flexGrow: 1
  }, children: /* @__PURE__ */ jsx(MuiAppBar, { position: Positioning.static, color: "transparent", sx: {
    backgroundColor: theme.palette.background.paper
  }, elevation: 0, ...rest, children: /* @__PURE__ */ jsx(Toolbar, { sx: {
    gap: isMobile ? theme.spacing(0) : theme.spacing(3)
  }, children }) }) });
}
const Toolbar = styled(Toolbar$1)(({
  theme: theme2
}) => ({
  display: Displaying.flex,
  justifyContent: Alignment.spaceBetween,
  padding: `${theme2.spacing(3)} ${theme2.spacing(3)}`,
  borderBottom: `1px solid ${Border.main}`,
  [theme2.breakpoints.up("sm")]: {
    paddingLeft: theme2.spacing(12),
    paddingRight: theme2.spacing(12)
  }
}));
export {
  AppBar
};
//# sourceMappingURL=app-bar.es.js.map
